import styled from 'styled-components';

// We can reuse the styles we've already built!
export { 
  PageTitle,
} from '../common/common.styles';

export { 
  FormPageContainer, 
  FormBox, 
  FormTitle, 
  Input, 
  Button 
} from '../common/Form.styles';

export const StyledSelect = styled.select`
  width: 100%;
  padding: 12px 15px;
  margin-bottom: 15px;
  border: 1px solid ${({ theme }) => theme.cardBorder};
  border-radius: 8px;
  font-size: 16px;
  background-color: ${({ theme }) => theme.inputBg};
  color: ${({ theme }) => theme.heading};
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primary};
  }
`;